import { render, staticRenderFns } from "./BuyInfo.vue?vue&type=template&id=2e55095e&scoped=true&"
import script from "./BuyInfo.vue?vue&type=script&lang=js&"
export * from "./BuyInfo.vue?vue&type=script&lang=js&"
import style0 from "./BuyInfo.vue?vue&type=style&index=0&id=2e55095e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e55095e",
  null
  
)

export default component.exports